import React, { useEffect, useState } from 'react';

const ScrollThread = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (totalHeight > 0) {
        setScrollProgress(window.scrollY / totalHeight);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Wavy path formula for viewport height
  // A vertical line with a few smooth waves
  const path = `M 10,0 Q 25,200 10,400 T 10,800`;

  // We will animate the stroke dash based on scrollProgress
  const pathLength = 805; // approximate length of the SVG path
  const strokeDashoffset = pathLength - (scrollProgress * pathLength);

  // Calculate coordinates of the glowing tip along the path based on scroll progress
  // We can approximate the Y coordinate linearly and X based on the wave function
  const tipY = scrollProgress * 100; // in percent of viewport height

  return (
    <div className="scroll-thread-container" style={{
      position: 'fixed',
      left: 'max(15px, calc((100vw - 1360px) / 2))',
      top: 0,
      bottom: 0,
      width: '30px',
      zIndex: 100,
      pointerEvents: 'none',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }}>
      <svg
        viewBox="0 0 30 800"
        preserveAspectRatio="none"
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {/* Background track thread */}
        <path
          d={path}
          fill="none"
          stroke="rgba(255, 255, 255, 0.05)"
          strokeWidth="2"
        />

        {/* Foreground glowing filled thread */}
        <path
          d={path}
          fill="none"
          stroke="url(#threadGrad)"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeDasharray={pathLength}
          strokeDashoffset={strokeDashoffset}
          style={{
            filter: 'drop-shadow(0px 0px 8px rgba(20, 184, 166, 0.6))',
            transition: 'stroke-dashoffset 0.1s ease-out',
          }}
        />

        <defs>
          <linearGradient id="threadGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#14b8a6" />
            <stop offset="50%" stopColor="#6366f1" />
            <stop offset="100%" stopColor="#ec4899" />
          </linearGradient>
        </defs>
      </svg>

      {/* Floating glowing dot on viewport-space corresponding to scroll percentage */}
      <div
        style={{
          position: 'absolute',
          left: '10px',
          top: `${tipY}%`,
          transform: 'translate(-50%, -50%)',
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          background: '#14b8a6',
          boxShadow: '0 0 15px #14b8a6, 0 0 30px #14b8a6',
          transition: 'top 0.1s ease-out',
        }}
      />
    </div>
  );
};

export default ScrollThread;
